module.exports = __webpack_public_path__ + "static/blog-post-2-4598076fc524622967bbad406c69c8ba.png";